// css theme values
// saved in settings and found at /static/themes/{theme}.css
export const DARK_THEME = 'dark';
export const LIGHT_THEME = 'light';
